import React, { useState } from 'react'
import styled from 'styled-components'
import Alink from 'estimate_list/libs/alink'

const ItemInfoList = ({ title, data, type }) => {
    const [view, setView] = useState(false)

    return (
        <Style>
            <dt>
                {title} <span className="num">{data.length}</span>
            </dt>
            <dd className={view ? 'active' : ''}>
                <button onClick={() => setView((s) => !s)}>
                    <i className={`icon-${view ? 'remove' : 'add'}`} />
                </button>
                <ul>
                    {type === 'stdpc' && (
                        data.map((v, i) => (view ? true : i === 0) && (
                            <li key={v.item_id}>
                                <Alink href={`${process.env.REACT_APP_SHOPPING_URL}/detail/${v.item_id}/${v.idx_b_manager}`}>{v.item_name}</Alink>
                            </li>
                        ))
                    )}
                    {type === 'event' && (
                        data.map((v, i) => (view ? true : i === 0) && (
                            <li key={v.idx_cat_evt}>
                                <Alink href={`${process.env.REACT_APP_EVENT_URL}/detail/${v.idx_cat_evt}`}>{v.nm_evt}</Alink>
                            </li>
                        ))
                    )}
                </ul>
            </dd>
        </Style>
    )
}

const Style = styled.dl`
    overflow: hidden;
    color: #999;
    line-height: 18px;

    dt {
        float: left;
        width: 120px;
    }
    dd {
        float: left;
        position: relative;
        padding: 0 0 0 20px;
        max-width: 410px;

        &.active {
            ul {
                height: auto
            }
        }
        button {
            position: absolute;
            top: 3px;
            left: 0;
            width: 13px;
            height: 13px;
            line-height: 10px;
            font-size: 12px;
            text-align: center;
            border: 1px solid #ccc;
            color: #f34522;
            background: #fff;
        }
        ul {
            overflow: hidden;
            height: 18px;

            li {
                a {
                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        }
    }
    .num {
        color: #418ded;
    }
`

export default ItemInfoList



// WEBPACK FOOTER //
// ./src/estimate_list/components/list/item_info_list.js